export default class VideoModal {
	static instance = null;

	static create(data) {
		const playBtn = data.querySelector('.play-btn');

		const videoModal = document.querySelector('#video-modal');
		if (!playBtn || !videoModal) {
			return null;
		}

		if (!VideoModal.instance) {
			VideoModal.instance = new VideoModal(playBtn, videoModal);
		}

		return VideoModal.instance;
	}

	static destroy() {
		if (VideoModal.instance) {
			VideoModal.instance.beforeDestroy();
			VideoModal.instance = null;
		}
	}

	constructor(playBtn, videoModal) {
		if (VideoModal.instance) {
			return VideoModal.instance;
		}

		this.playBtn = playBtn;
		this.videoModal = videoModal;
		this.closeBtn = document.querySelector('.modal-close-btn');
		this.iframeHtml = document.querySelector('#video-modal iframe');
		this.modalContent = document.querySelector('.modal-content');
		this.body = document.body;
		this.videoModalParent = this.videoModal.parentNode;
		this.videoModalParent.removeChild(this.videoModal);

		setTimeout(() => {
			this.body.appendChild(this.videoModal);
		}, 100);

		if (!this.iframeHtml) {
			return null;
		}

		this.iframeHtml.style = '';
		this.iframeHtml.remove();

		this.playClick = this.playClick.bind(this);
		this.closeClick = this.closeClick.bind(this);
		this.documentClick = this.documentClick.bind(this);

		this.init();
	}

	init() {
		this.playBtn.addEventListener('click', this.playClick);
		if (this.closeBtn) {
			this.closeBtn.addEventListener('click', this.closeClick);
		}
		document.addEventListener('click', this.documentClick);
	}

	playClick() {
		this.modalContent.append(this.iframeHtml);
		setTimeout(() => {
			this.body.classList.add('modal-active');
		}, 100);
		this.videoModal.style.display = 'flex';
		this.playBtn.style.display = 'none';
	}

	closeClick() {
		this.hideModal();
		this.playBtn.style.display = 'block';
	}

	documentClick(e) {
		if ((this.body.classList.contains('modal-active')) && (!e.target.closest('iframe'))) {
			this.hideModal();
			this.playBtn.style.display = 'block';
		}
	}

	hideModal() {
		this.body.classList.remove('modal-active');
		this.videoModal.style.display = 'none';
		if (this.iframeHtml) {
			this.iframeHtml.remove();
		}
	}

	beforeDestroy() {
		this.playBtn.removeEventListener('click', this.playClick);
		if (this.closeBtn) {
			this.closeBtn.removeEventListener('click', this.closeClick);
		}
		document.removeEventListener('click', this.documentClick);
		this.body.removeChild(this.videoModal);

	}
}
